/*
创建者 李伟(2018.5.31)
中国地标优品
*/
<template>
  <div id="landmark-product">
    <div class="landmark-product-top" :style="{background:`url(${topImgBg})`}"></div>
    <div class="wrapper">
      <div class="landmark-product-title lp-hot" :style="{background:`url(${titleBg})`}"></div>
      <div class="home-module">
        <div class="brandList clearfix">
          <div class="brandList-item">
            <ul>
              <li v-mouseenter
                  v-for="(item,index) in productlist.hotCityAdvertisementDTO.advList"
                  :class="{active:index==0}"
                  :key="index"
                  :style="{backgroundImage:`url(${item.atturl})`}">
                <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="landmark-product-title lp-hd" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-2-6">
        <ul>
          <li v-for="item in productlist.eastChinaAreaAdvertisementDTO.advList">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-hz" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-1-4">
        <ul>
          <li v-for="item in productlist.inCentralChinaAdvertisementDTO.advList">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-hb" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-2-5">
        <ul>
          <li v-for="(item,index) in productlist.inNorthChinaAdvertisementDTO.advList" :class="{smallImg:index==0||index==1||index==2} ">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-hn" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-1-3">
        <ul>
          <li v-for="item in productlist.inSouthChinaAdvertisementDTO.advList">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-xb" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-2-5">
        <ul>
          <li v-for="(item,index) in productlist.theNorthwestRegionAdvertisementDTO.advList" :class="{smallImg:index==0||index==1||index==2} ">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-xn" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-2-5">
        <ul>
          <li v-for="(item,index) in productlist.inTheSouthwestAdvertisementDTO.advList" :class="{smallImg:index==0||index==1||index==2} ">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-db" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-1-3">
        <ul>
          <li v-for="item in productlist.inTheNortheastAdvertisementDTO.advList">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
      <div class="landmark-product-title lp-gat" :style="{background:`url(${titleBg})`}"></div>
      <div class="landmark-item product-list-1-3">
        <ul class="clearfix">
          <li v-for="item in productlist.specialAreaAdvertisementDTO.advList">
            <router-link :to="{ path: 'landmark-goods-list', query: {regionId:item.url, aname: item.aname}}">
              <img :src="item.atturl" height="100%" width="100%">
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import topImgBg from '../../assets/images/landmark-product-top.jpg';
import titleBg from '../../assets/images/landmark-product-title.png';
import {getAreaPage} from 'api/home.js';
export default {
	data(){
		return{
      topImgBg,
      titleBg,
      productlist:{
        eastChinaAreaAdvertisementDTO:{},
        hotCityAdvertisementDTO:{},
        inCentralChinaAdvertisementDTO:{},
        inNorthChinaAdvertisementDTO:{},
        inSouthChinaAdvertisementDTO:{},
        inTheNortheastAdvertisementDTO:{},
        inTheSouthwestAdvertisementDTO:{},
        specialAreaAdvertisementDTO:{},
        theNorthwestRegionAdvertisementDTO:{}
      }
		}
	},
  directives:{
    mouseenter:{
      inserted:function(el){
        $(el).bind("mouseenter",function(){
          $(this).siblings().removeClass('active');
          $(this).stop().stop().animate({width:674},500).siblings().stop().animate({width:68},500);
        });
      }
    }
  },
	created(){
    this.getAreaPagelist();
	},
	methods:{
    getAreaPagelist(){
      getAreaPage().then((json) => {
        if (json.resCode == '1') {
          this.productlist = json.data;
          if(this.productlist){
            for(var i in this.productlist){
              for(var j in this.productlist[i].advList){
                this.productlist[i].advList[j].description = this.productlist[i].adColumn.description
              }
            }
          }
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    }
	}
}
</script>

<style lang="less">
  @import "../../assets/css/landmark-product.less";
</style>



// WEBPACK FOOTER //
// index.vue?66ab21ef